import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

interface Props {
  logo: React.ReactElement;
  title: string;
  path: string;
  selected: boolean;
  onClick: () => void;
}

const Box = styled.div<ButtonProps>`
  height: 80px;
  width: 80px;
  border: 1px solid #d9d9d9;
  display: flex;
  flex-direction: column;
  background-color: ${props => (props.selected ? '#707070' : '#F7F7F7')};
`;

interface ButtonProps {
  selected: boolean;
}

const Icon = styled.div<ButtonProps>`
  width: 24px;
  height: 24px;
  margin-left: 28px;
  padding-top: 22px;
  fill: ${props => (props.selected ? '#F7F7F7' : '#707070')};
`;

const Text = styled.div<ButtonProps>`
  margin: auto;
  font-size: 8px;
  text-transform: uppercase;
  text-decoration: none;
  color: ${props => (props.selected ? '#F7F7F7' : '#707070')};
`;

const ButtonLink = styled(Link)`
  text-decoration: none;
`;

const DrawerButton: React.FunctionComponent<Props> = props => {
  return (
    <ButtonLink to={props.path}>
      <Box selected={props.selected} onClick={props.onClick}>
        <Icon selected={props.selected}>{props.logo}</Icon>
        <Text selected={props.selected}>{props.title}</Text>
      </Box>
    </ButtonLink>
  );
};

export default DrawerButton;
